module.exports = __webpack_public_path__ + "static/img/icon_hzb.2f6c237f.png";